import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Zap, Flame, Users } from 'lucide-react';

const TABS = [
  { path: '/',        label: 'Quick Play', icon: Zap,   match: (p) => p === '/' || p.startsWith('/tournament') },
  { path: '/streaks', label: 'My Cardio',  icon: Flame, match: (p) => p.startsWith('/streaks') },
  { path: '/rivals',  label: 'Rivals',     icon: Users, match: (p) => p.startsWith('/rivals') },
];

/**
 * Persistent 3-tab bottom navigation for the public player flow.
 * Renders fixed at the bottom of the viewport with safe-area padding.
 */
export default function BottomNav() {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <nav
      className="fixed bottom-0 inset-x-0 z-30 bg-card/95 backdrop-blur border-t border-border safe-bottom"
      data-testid="bottom-nav"
    >
      <div className="max-w-md mx-auto grid grid-cols-3">
        {TABS.map((t) => {
          const active = t.match(location.pathname);
          const Icon = t.icon;
          return (
            <button
              key={t.path}
              onClick={() => navigate(t.path)}
              className={`flex flex-col items-center justify-center gap-0.5 py-2 transition-colors ${
                active ? 'text-primary' : 'text-muted-foreground hover:text-foreground'
              }`}
              data-testid={`bottom-nav-${t.label.toLowerCase().replace(' ', '-')}`}
            >
              <Icon className={`h-5 w-5 ${active ? 'fill-primary/15' : ''}`} />
              <span className="text-[10px] font-bold uppercase tracking-wide">{t.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
